// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"524":"bb5b2d87226d2f4756a4","852":"d851c45af4aa62e2ee10"}[chunkId] + ".css";
};